import autobind from 'core-decorators/lib/autobind';
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import {scroller} from 'react-scroll';
import GetStartedPopup from './GetStartedPopup';
import Link from 'react-router-dom/Link';
import { withRouter } from "react-router-dom";
// import FacebookLoginButton from '../components/FacebookLoginButton';

@autobind
class Header extends React.Component {
  state = {
    getStarted:false,
  };


  getStarted(){
    this.setState({getStarted:true});
    var redirect;
    if(process.env.NODE_ENV === "development"){
      redirect = "https://api.instagram.com/oauth/authorize/?client_id=7f3eca98290b4b829c345888daebd8c4&redirect_uri=http://start.localhost:4000/login&response_type=code";
    } else if(process.env.NODE_ENV === "test"){
      redirect = "https://api.instagram.com/oauth/authorize/?client_id=7f3eca98290b4b829c345888daebd8c4&redirect_uri=https://start.minimaa.io/login&response_type=code";
    } else {
      redirect = "https://api.instagram.com/oauth/authorize/?client_id=7f3eca98290b4b829c345888daebd8c4&redirect_uri=https://start.minimaa.co/login&response_type=code";
    }
    setTimeout( function() { window.location = redirect }, 500 );
  }

  render() {
  
    return (
      <div className={css(styles.wrapper)}>
        <GetStartedPopup getStarted={this.state.getStarted} />
        <div className={css(styles.innerWrapper)}>
          <div className={css(styles.logoWrapper)}>
            <Link onClick={()=>window.scrollTo(0,0)} to="/">
              <img className={css(styles.logo)} alt="minimaa logo" src="../assets/logo.svg" />
            </Link>
          </div>
          <div className={css(styles.linksWrapper)}>
            <div className={css(styles.link)}
            onClick={
              () => {
                this.props.history.push("/")
                setTimeout(()=>{
                  scroller.scrollTo("showcase",
                  {duration: 400,delay: 0,smooth: true,offset: 0,}
                  )
                }, 200);
                setTimeout(()=>{ window.location.hash='showcase' }, 800);
                  
              }
            }
            >EXAMPLE</div>
            <div className={css(styles.link)}
            onClick={
              () => {
                this.props.history.push("/")
                setTimeout(()=>{
                  scroller.scrollTo("how-it-works",
                    {duration: 400,delay: 0,smooth: true,offset: 0,}
                  )
                }, 200);
                setTimeout(()=>{ window.location.hash='how-it-works' }, 800);
                  
              }
            }
            >HOW</div>
            <div className={css(styles.link)}
            onClick={
              () => {
                this.props.history.push("/")
                setTimeout(()=>{
                  scroller.scrollTo("benefits",
                    {duration: 400,delay: 0,smooth: true,offset: 0,}
                  )
                }, 200);
                setTimeout(()=>{ window.location.hash='benefits' }, 800);
                  
              }
            }
            >WHY</div>
            <div className={css(styles.link)}
            onClick={()=>this.props.history.push("/pricing")}
            >PRICING</div>
          </div>
         
            
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  wrapper: {
    position:"relative",
    width:"100%",
    // margin:"0 auto",
    // maxWidth:1250,
  },
  innerWrapper:{
    display:"flex",
    alignItems:"center",
    justifyContent: 'space-between',
    margin:"0 auto",
    height:125,
    width:"calc(100% - 200px)",
    '@media (max-width: 1400px)': {
      width:"calc(100% - 120px)",
    },
    '@media (max-width: 950px)': {
      width:"calc(100% - 50px)",
      height:100,
    },
    '@media (max-width: 500px)': {
      height:100,
      width:"calc(100% - 60px)",
    },
    '@media (max-width: 420px)': {
      width:"calc(100% - 20px)",
      maxWidth:335,
    },
    '@media (max-width: 340px)': {
      height:100,
      width:"calc(100% - 40px)",
    },
  },
  button:{
    position:"relative",
    color:"#fff",
    textDecoration:"none",
    outline:"none",
    display:"flex",
    justifyContent:"center",
    alignItems:"center",
    border:"2px solid #000",
    padding:"9px 16px 8px 14px",
    cursor:"pointer",
    borderRadius:"25px",
    fontSize:12,
    lineHeight:"14px",
    letterSpacing: "0.163636px",
    fontWeight:500,
    transition:"0.3s",
    background:"#000",
    ":hover":{
      color:"#fff",
      border:"2px solid #000",
    },
    '@media (max-width: 420px)': {
      fontSize:14,
    }
  },
  buttonImg:{
    width:16,
    marginTop:-1,
    marginRight:10,
  },
  linksWrapper:{
    display:"flex",
    marginRight:60,
    '@media (max-width: 880px)': {
      marginRight:20,
    },
    '@media (max-width: 700px)': {
      marginRight:18,
    },
    '@media (max-width: 660px)': {
      display:"none",
    },
  },
  link:{
    letterSpacing: "0.190909px",
    marginRight:20,
    fontSize:12,
    fontWeight:500,
    cursor:"pointer",
    transition:"0.2s ease-in-out",
    ":hover":{
      opacity:0.6,
    },
    '@media (max-width: 700px)': {
      marginRight:10,
    },
  },
  logoWrapper:{
    flexGrow:100,
  },
  logo:{
    width:115,
    marginBottom:-4,
  },
  
});

export default withRouter(Header);
